const en = {
  labels: {
    email: "Email",
    password: "Password",
    name: "Name",
    lastName: "Last Name",
    birthDate: "Birthdate",
    timeZone: "Time Zone",
    city: "City",
    position: "Position (CTO, employee, etc.)",
    newPassword: "New Password",
    confirmPassword: "Confirm Password",
    biography: "What do you want other users to know about you?",
    motto: "Motto (ex. Memento mori!!)",
    twitter: "Twitter",
    linkedin: "LinkedIn",
    Spotify: "Spotify",
    web: "Web Page",
    message: "Type your message here",
    messageDisabled: "You can write in 5 seconds",
    users: "Users",
    user: "User",
    sound: "Sound",
    mic: "Mic",
    speakers: "Audio output",
    camera: "Camera",
    sharing: "Sharing",
    spaceName: "Space Name",
    superSpaceName: "Campus Name",
    multiWebinar: "Multiwebinar: Connect the webinars of all spaces into one",
    returnToTheCity: "This campus has access to the city",
    isPublic: "This campus is public for all nubi users",
    welcomeText: "Welcome message",
    scene: "Scene",
    url: "URL (Optional)",
    room: "Room",
    wonderPointUrl: "URL of the website that will appear in the description",
    videoUrl: "Video pinned to room",
    lockVideoUrl: "Keep video in the room",
    roomName: "Room Name",
    posterName: "Poster name",
    automaticWonderPoint: "Automatically open in a new tab.",
    reason: "Reason",
    search: "Search",
    filters: "Filters",
    permissions: "Permissions",
    required: "Required",
    optional: "Optional",
    description: "Description",
    comingBack: "I'm coming back the",
    addEmails:
      "Add emails to send guest invites or user links, use comas bewteen emails to add several users",
    sentAt: "Sent at",
    invitedBy: "Invited by",
    sentDate: "Send date",
    type: "Type",
    invitation: "Invitation",
    userInvitationType: "Regular User",
    invitedInvitationType: "Invited",
    publicInvitationType: "Public",
    customInvitationType: "Custom",
    notFound: "Not found",
    used: "Invitation used",
    expireDate: "Expiration date",
    yes: "Used",
    no: "Without using",
    publicUrl: "Url pública",
    maxCharacters: " (Max character: {number})",
    withSound: "With sound in rooms",
    withoutSound: "Without sound",
    hasSent: "has sent",
    speedNetworkingDuration: "Speed Networking calls duration (minutes)",
    spaceType: "Space type",
    creatorEmail: "Creator email",
    generalChatEnable: "Enable general chat in space",
    webinarChatEnable: "Enable chat in space webinars",
    chatNameDefault: "Room chat",
    selectPlace: "Where do you want to go today",
    addFavourite: "Add to Favorites",
    removeFavourite: "Remove from favorites",
    free: "Entry available",
    almostFull: "Almost full",
    full: "Space Full",
    itemsPerPage: "Items per page",
    language: "languages I can speak/understand",
    titleProfileObboarding:
      "Fill in what you want OTHER AVATARS to know about you.",
    profileObboarding:
      "You will be able to copy their shared info and they will be able to copy yours. Let them know how to contact you after they meet you.",
    permanentlyBlock: "Lock room permanently",
    date: "Date",
    status: "Status",
    showLogsOf: "Show logs of:",
    downloadCsv: "Download CSV",
    from: "From",
    to: "To",
    spaces: "Spaces",
    favoriteCampus: "Favorite",
    publicCampus: "Public",
    otherCampus: "Campus to which you have been invited",
    disabledPassword:
      "The password is disabled because the Multi Webinar is active",
    showText: "Type the text to be displayed (optional)",
    poster: "Poster",
    externalDashboardUrl: "External url for the dashboard",
    pin: "Pin",
    lowBandWidth: "Low bandwidth",
    experienceTag: "What do you have more experience in?",
    learningTag: "What would you like to learn/know?",
    projectParticipationTag: "Projects/Type of projects in which you have participated?",
    addTag: "Add tag",
    showExperienceTag: "My experience",
    showLearningTag: "I would like to learn/know",
    showProjectParticipationTag: "Types of projects in which I have participated",
    activateNotepad: "Activate notepad",
    notepadText: "Notepad text",
    notepadRoom: "Room notepad",
    tags: "Tags",
    projects: "Projects",
    knowledge: "Skill",
    experts: "Experts",
    contactAddress: "Contact Address",
    phone: "Phone Number",
    link: "Link of Interest",
    nationality: "Nationality",
    personalInformation: "Personal Information",
    gender: "Gender",
    title: "Title",
    groupMembers: "Group members",
    moreInformation: "More information",
    spaceDefault: "Default space",
    reservePhysicalRoom: {
      imagen: "Image",
      physicalRooms: "Physical rooms",
      titlePlant: "Plant name",
      floorPlanImage: "Floor plan image",
      rooms: "Rooms"
    },
    workExperiences: {
      title: "Work Experience",
      position: "Position",
      startAt: "Start Date",
      endAtAt: "End Date",
      company: "Company",
      companyType: "Type of Company",
      description: "Description",
    },
    educations: {
      title: "Education/Training",
      educationalDegree: "Educational Degree",
      startAt: "Start Date",
      finishAt: "End Date",
      place: "Place",
      description: "Description",
    },
    languageSkills: {
      title: "Languages",
      language: "Language",
      listeningSkill: "Listening Skill",
      speakingSkill: "Speaking Skill",
      readingSkill: "Reading Skill",
      writingSkill: "Writing Skill",
    },
    digitalSkill: {
      title: "Digital Skills",
      informationProcessing: "Information Processing",
      communication: "Communication",
      contentCreation: "Content Creation",
      safety: "Safety",
      problemSolving: "Problem Solving"
    },
    otherSkill: {
      title: "Other Skills",
      communication: "Communication",
      organizationalOrManagement: "Organizational or Management",
      teamWork: "Team Work",
      drivingLicense: "Driving License",
    },
    aboutYou: {
      title: "What do you consider yourself good at professionally?",
      aboutYou: "What we aim for is that whenever a colleague needs to solve a problem, they can rely on you. Describe everything you believe they might consult you for help with.",
      message: "Write here",
    }
  },
  sidebar: {
    nubiiSpace: "nubi Space",
    usersInSpace: "Users in space",
    usersOnline: "Active Users",
    noMatches: "No Matches",
    messages: "Messages",
    footer: {
      help: "Help and Support",
      legalTerms: "Legal Terms",
      suggestions: "Suggestions?",
      defaultSpot: "Default location",
    },
  },
  buttons: {
    logIn: "Log In",
    send: "Send",
    save: "Save",
    changeEmail: "Change Email",
    yes: "Yes",
    no: "No",
    delete: "Delete",
    edit: "Edit",
    changeScene: "Change Scene",
    changeSpace: "Change Space",
    removeImagen: "Remove logo image",
    removeImagenPoster: "Remove poster image",
    removeImageRoom: "Remove image from room",
    removeImagenScreenRoom: "Remove images from room screens",
    goToSpace: "Go to Space",
    cancel: "Cancel",
    accept: "Accept",
    copy: "Copy",
    copyUserInfo: "Copy user info",
    next: "Next",
    saveAndNext: "Save and next",
    exitToCity: "Exit to city",
    exitLeave: "Exit and leave nubi",
    start: "Start",
    backToNubii: "Back to nubi",
    imReady: "I'm ready!",
    skip: "Skip this step",
    letsGo: "Let's go",
    openUrl: "Open web",
    goTo: "Go to the booth",
    openInTab: "Open in tab",
    iKnow: "Ok, continue",
    sendInfoUserEmail: "Send information to my email",
    createSpace: "Create space",
    showProfile: "Show profile",
    enter: "Enter",
    inviteMoreUsers: "Invite more users",
    sendNewMessage: "Send new message",
    newMessage: "New messages",
    backGame: "Back to the game",
    addSpace: "Add  space",
    inviteFriend: "Invite friend",
    showRooms: "Show rooms",
    enterInSpace: "Enter space",
    showAll: "Show all",
    iNeedHelp: "I need help...",
    deleteVideo: "Remove vídeo",
    reload: "Update spaces",
    unsubscribe: "Delete my account",
    addUrl: "Add invite link",
    addVisitSpace: "Add visit to a space",
    clearChat: "Clear chat",
    programNotification: "Scheduled announcements",
    usersGroup: "Users Group",
    openDashboardUrl: "Show activity dashboard",
    gotoCity: "Go to city",
    retryPin: "Forward email with PIN number",
    reloadNubi: "Reload",
    cleanAndStart: "Clean and start",
    sendReport: "Send report",
    congratulate: "Say Congratulations",
    notepad: "Notepad",
    createSpaceOrHelp1: "Click",
    createSpaceOrHelp2: "if you want to create your own nubi space. Or contact us ",
    createSpaceOrHelp3: "to help you understand how our customers use it.",
    here: "here",
    activate: "Activate",
    disable: "Disable",
    add: "Add",
    sendCurriculum: "Send Curriculum",
    updateCurriculum: "Update Curriculum",
    deleteCurriculum: "Delete Curriculum",
    hide: "Hide",
    close: "Close",
  },
  tooltips: {
    exit: "Exit",
    spaceLabels: "Labels",
    noWall: "Hide walls",
    rotate: "Rotate the camera to refresh",
    disableNoWall: "In this space, it is not possible to use this functionality",
    mode3D: "3D Mode",
    mode2D: "2D Mode",
    activateCamera: "Enable camera",
    deactivateCamera: "Disable camera",
    activateMic: "Enable microphone",
    deactivateMic: "Disable microphone",
    shareScreen: "Share screen",
    unShareScreen: "Stop screen",
    noWorkingTeams1: "MS Teams does not allow screen sharing to external apps like nubi. To use it you have to ",
    noWorkingTeams2: "open nubi in a separate tab",
    openChat: "Open chat",
    config: "Call options",
    expand: "Expand",
    contract: "Collapse",
    endCall: "End call",
    enterCall: "Take call",
    editProfile: "Edit profile",
    changeEmoji: "React",
    busy: "Busy",
    call: "Available",
    cameraOptions: "Navigation",
    angles: "Angles",
    moveSpace: "Move Space",
    zoom: "Zoom",
    centerMyAvatar: "Center my avatar",
    deleteInvitation: "Delete invitation",
    increaseInvitation: "Increase expiration",
    question: "Question",
    sendQuestion: "Send the message as a question",
    send: "Send",
    enter: "Enter",
    paperPlane: "Paperplane",
    global: "Announcement",
    pinnedBy: "Pinned by",
    deletePinned: "Delete pinned message",
    hide: "Hide",
    callBack: "Return to call",
    changePin: "Change ACCESS code",
    textChangePin:
      "This room is permanently blocked from the space administrator",
    handUp: "Raise your hand",
    disableSpace: "Space is disabled",
    deleteUser:
      "Your user has been removed from this space. You can only access again if you are sent an invitation.",
    disableUser: "You are banned from this space. Contact the administrator.",
    activeInSuperSpace: "This permissions is active on campus",
    imHome: "I'm home",
    imOffice: "I am in the office",
    shareVideo: "Share video",
    diary: "Diary",
    buzz: "Buzz",
    mute: "Mute",
    noShowCam: "Turn off camera",
    changeLayout: "Change camera layout",
    focusModeOn: "Enable focus mode",
    focusModeOff: "Disable focus mode",
    disableSpaceNubi: "Space has been disabled by nubi",
    noSend: "Maximum characters exceeded",
    searchFilters: "Search filters",
    filtersKnowledge: "By checking this option, users with this experience or who want to learn it will be shown",
    filtersProjects: "Checking this option will show the users who participate in the project",
    filtersExperts: "By selecting this option, users who are experts will be displayed",
    deleteImage: "Remove image",
    addImage: "Add image",
    changeImage: "Change image",
    imageNotSaved: "Image not saved",
    notCompatibleSafari: "Cannot currently share screen with Safari",
    delete: "Delete",
    edit: "Edit",
    addUserAndDelete: "(Add / Delete) users",
    dragUsers: "You can move users from one field to another by dragging them",
    disableGame: "To activate the game, 3 players online are needed",
    activeGame: "Upon activation, the game will initialize",
    info: "Information",
    save: "Save",
  },
  validatorError: {
    required: "The field is required",
    email: "You must enter a valid email address",
    minLength: "The password must be at least {count} characters long.",
    sameAs: "Passwords do not match",
    invalidUrl: "Invalid Url, should be https://www.example.com",
  },
  notifications: {
    titles: {
      error: "Ups!",
      success: "Great!",
      information: "Information",
      requestPassword: "Request Password Change",
    },
    descriptions: {
      userBan: "Usuario baneado exitosamente",
      userUpdate: "Profile successfully updated",
      spaceUpdate: "Space successfully updated",
      urlUpdate: "Url successfully updated",
      emojiUpdate: "Emoji successfully updated",
      avatarUpdate: "Avatar successfully updated",
      petUpdate: "Pet successfully updated",
      roomUpdate: "Room Successfully modified",
      posterUpdate: "Successfully Modified Poster",
      reasonUpdate: "Reason successfully updated",
      requestPassword:
        "An e-mail has been sent to {email} to change the password.",
      resetPassword: "Changed password",
      deleteSpaceUser: "User removed from space",
      activeSpace: "The space has been activated successfully",
      activeSpace2:
        "Check your email one last time to log into your new nubi space",
      copyUrl: "Url copied to clipboard",
      copyInfo: "Information copied to clipboard",
      confirmEmail: "Confirmation email sent successfully",
      skip: "Are you already an expert using nubi? if you want you can skip this step.",
      successActivateUser:
        "User successfully activated, if you are a new user check your mailbox, we have sent your credentials to access nubi, if not, you can enter directly from nubi’s login page.",
      sendInvitations: "Invitations sent satisfactorily",
      vacationOn: "Vacation successfully updated",
      deleteInvitation: "Invitation delete satisfactorily",
      increaseInvitation: "Expiration time increased satisfactorily",
      recoveringPassword: "We have sent an email for recovering password.",
      emailNotRegistered: "This email is not registered on nubi.",
      waitSendRecoveryPassword:
        "You must wait 5 minutes for requesting password again.",
      muteExternalMic: "has muted your microphone",
      stopExternalCam: "has turned off your camera",
      buzzed: "it's buzzing you",
      recommendTurningOff:
        "It seems that you have a very low bandwidth, we recommend you turn off your camera",
      sendInfoEmail: "User information sent to your email successfully.",
      deleteSpace: "Space deleted successfully",
      createSpace: "Space created successfully",
      chatCopied: "Chat copied to clipboard",
      pinnedMessage: "Message pinned successfully",
      deletePinnedMessage: "Message pinned deleted successfully",
      disableUser: "User successfully disabled",
      spaceFull: "Space is full, please select another.",
      assignedMyPlaceDefault:
        "Assigned your place by default. From now on, when you enter nubi or momentarily lose connection, you will go directly to that site.",
      calendarUpdate: "Calendar updated successfully",
      videoAudio: "Video and Audio updated successfully",
      pinRequest:
        "Now! Perfect. We have sent you an email with your PIN number, Access for ONE USE ONLY. If you don’t see it within a few seconds, check your SPAM folder",
      pinErrorUserNotExist: "We don’t have this email as a nubi user.",
      pinInvalidCredentials: "Incorrect email or PIN.",
      pinRequestApin: "Ask for a PIN.",
      pinExceeded:
        "You have passed login attempts with this pin. Ask for a nex one.",
      pinExpired: "The PIN has expired. Ask for a new one.",
      sendReport: "Report sent successfully",
      autoplayCheckT: "It has been detected that the video is configured to start playing from a specific second. Autoplay only works when the video starts from the beginning.",
      permissionError: "Can't access permissions",
      sendReportOk: "The report has been sent",
      sendVoteOk: "The vote has been sent",
      createGroup: "Group created",
      editGroup: "Group edited",
      removeGroup: "Group deleted",
      createCurriculum: "Curriculum created successfully",
      updateCurriculum: "Curriculum updated successfully",
      deleteCurriculum: "Curriculum deleted successfully",
      createReserve: "Reservation successfully created",
      updateReserve: "Reservation successfully updated",
      removeReserve: "Reservation successfully removed",
      reserveRoomStart: "The room is reserved",
      reserveRoomFinish: "The reservation has ended",
      saveAutoVideo: "Recording saved successfully",
      createPhysicalPlantAndRoom: "Successfully saved",
    },
    newMessage: {
      title: "nubi message received",
      titleRoom: "nubi message received in the room",
      body: "{name} has sent you a message",
      bodyRoomGeneral: "{name} has sent you a message to the general chat",
      bodyRoomRoom: "{name} has sent you a message to the chat room",
      bodyRoom: "{name} has sent a message",
      sendNewMessage: "Message sent successfully",
    },
    newConsoleMessage: "{name} has sent an announcement",
    openWebinar: "{name} {lastname} has started the webinar",
    closeWebinar: "{name} {lastname} has finished the webinar",
    newPaperPlane: "{name} {lastName} has sent you a paper plane",
    newPaperPlaneApp:
      "{name} {lastName} is connected from nubi app, the paper plane has been sent from {room}",
    sendNewPaperPlane: "You have sent a paper plane",
    sendBirthdayCake: "{name} {lastName} has sent you a birthday cake",
    permissionsOk: {
      title: "Notifications on",
      body: "Notifications were successfully activated",
    },
    announcement: "Announcement",
    warningMessages: {
      youAreOnCall: "You are already on a call.",
      isBusy: "{name} is busy.",
      triedCallYou: "{name} tried to call you",
      emojiIsNotChangedOnCall:
        "You cannot change the emoji if you are on a call.",
      stateIsNotChangedOnCall:
        "You cannot change the status if you are on a call.",
      connectionIsLow:
        "We have detected that the connection is too slow, please wait.",
      emailInSpace: "Already exists within space",
      emailErrorGuest: "Guest users are not allowed to use user invitation",
      nextMaintenance:
        "Hello, in nubi we are undergoing renovations.<br>At <b>{date}</b><br>we have to close our facilities for a few minutes to finish painting, hang some pictures and.... make nubi the best tool for remote people. Stay tuned!",
    },
    errorMessages: {
      connectionIsLowRefresh:
        "We have not been able to load the necessary files for nubi to work, your computer or your connection may have problems.",
      connectionIsLowRefreshClick: "click here",
      connectionIsLowRefresh2: "to retry.",
      reasonUpdate: "The reason could not be updated correctly",
      updatePerfil: "Could not update profile, please try again later.",
      invalidCredentials: "Incorrect e-mail or password",
      invalidPassword: "Incorrect password",
      resetPassword:
        "Your password could not be changed, please try again or contact support.",
      pusherError:
        "Channels are not supported by the browser, please contact support.",
      spaceDisabled:
        "The space is disabled, select another one or contact support.",
      spaceUserDisabled:
        "Your user has been disabled by the administrator of this space.",
      userBanned: "The user is disabled. Please contact support.",
      userDelete: "The user has been deleted. Please contact support.",
      userSpaceBanned:
        "The user is disabled from the space, select another one or contact support.",
      spaceDelete: "The space has been deleted, please contact support.",
      spaceUserDelete:
        "The user has been deleted from the space, please contact support.",
      invitationExpired: "The invitation is invalid or has already expired.",
      generateToken:
        "We were unable to generate the invitation, please try again or contact support.",
      activateUser:
        "We were unable to activate your account, please try again or contact support.",
      connectRoom:
        "Unable to connect to the call, please leave the room and try again",
      connectRoomError:
        "Failed to connect to the call",
      connectOneToOneError:
        "The other user is not on the call",
      maxFileSize:
        "The size of the image is not allowed, it must be less than 2mb",
      fileType: "Only png, jpg and jpeg files are allowed",
      linkCannotBeUsed: "The link cannot be used with that user",
    },
    noInternetConnection:
      "If you are offline, some functions may not be available.",
    noChrome:
      "nubi is optimized for the Google Chrome browser. You can download it for free from THIS LINK",
    noWebGl2:
      "nubi necesita que tengas habilitado WebGl2 en tu explorador. Realiza ESTE TEST para comprobar que esté habilitado",
    noMobile:
      "Currently, nubi only works on Google Chrome for desktop. We are working on making it accessible from more platforms.",
    downloadHere: "Download chrome here",
    testHere: "Ingresa a el test aquí",
    iploneMobile: "You can download the app for iPhone ",
    androidMobile: "You can download the app for Android ",
    here: "here",
    devices: {
      title: "Devices not configured",
      permissions:
        "In order for other users to see and hear you, you must give access permissions to your camera and microphone in your browser. Click on the lock icon in the address bar, allow access to audio and camera. After that, you must reload the page by pressing F5 on Windows or CMD+R on Mac.",
      withoutDevices:
        "Your browser is telling nubi that it hasn't found {devices}. Exit the room and go to the settings on the top right menu of nubi to select one from the list. If you don't see any installed, your browser is not detecting them. Try to verify the permissions by clicking on the lock icon in the address bar, and allow access to microphone and camera. After that, you should reload the page by pressing F5 on Windows or CMD+R on Mac. If none of this works, try restarting everything from scratch.",
      devices1: "no camera activated",
      devices2: "no active mic",
      devices3: "no camera or active microphone",
      noPermissions:
        "Your operating system or browser does not have permissions to use {devices}, check your system or browser settings and reload nubi by pressing F5 on Windows or CMD+R on Mac.",
      cam: "the cam",
      mic: "the mic",
      record: "screen recording",
      permissionDenied: "Permissions denied",
    },
    genericError: {
      genericError: "An error {code} has occurred, please contact support.",
      genericErrorRetry: "Ha ocurrido un error, por favor vuelva a intentarlo.",
      genericErrorClientGraphic:
        'An unexpected error has occurred. By pressing "Reload" we restart nubi. If the error persists, click on "Clean and start", which is more radical, and you will have to re-identify yourself or click on the invitation link.',
      genericErrorTeams:
        'An unexpected error has occurred. By pressing "Reload" we restart nubi. If the error persists, please contact support.',
      updateRoom:
        "An error occurred while updating the room, please contact support.",
      updateImage:
        "There has been an error in the upload. Please try again later",
      activeSpace:
        "An error occurred while activating the space, please contact support.",
    },
    errorCode: {
      "23bd9dbf-6b9b-41cd-a99e-4844bcf3077f": "E-mail is already in use.",
      "bd79c0ab-ddba-46cc-a703-a7a4b08de310":
        "This is not a valid e-mail address.",
    },
    apiMessage: {
      EMAIL_FOR_ACTIVATION_SENT:
        "We have sent an email to complete the activation.",
      ERROR_TOKEN_NOT_FOUND: "System cannot find the invitation to activate",
      ERROR_USER_INVITATION_ACTIVATED_ALREADY:
        "This invitation has already been activated",
      ERROR_USER_INVITATION_IS_DELETED: "This invitation has been deleted",
      ERROR_USER_BELONG_SPACE_ALREADY:
        "Welcome back! Redirecting you to your space...",
      ERROR_GUEST_USER_ARE_NOT_ALLOWED_TO_USE_USER_INVITATION:
        "Guest users are not allowed to use user invitation",
      ERROR_YOUR_USER_IS_BEING_CREATED_TRY_AGAIN:
        "Your user is being created. Click on the email link again in a few seconds",
      ERROR_INVITATION_HAS_EXPIRED: "This invitation has expired",
      ERROR_SPACE_IS_DELETED: "The space has been deleted",
      "name is required": "name is required",
      ERROR_SPACE_ACTIVATED_ALREADY: "This space has been activated already.",
      ERROR_SPACE_IS_BEING_CREATED_TRY_AGAIN:
        "Space is creating. Click on activation link in a few seconds",
      ERROR_SUPER_ADMIN_CANNOT_BE_INVITED: "Superadmin cannot be invited",
      SUPER_SPACE_NAME_EXISTS: "A Campus with this name already exists",
      ERROR_USER_BELONG_SPACE_ALREADY_NO_TOKEN:
        "Your user already belongs to this space, identify yourself to access it",
    },
  },
  status: {
    available: "Available",
    availableMessage: "Watch out! They may call you without warning",
    busy: "Busy",
    call: "Ring when calling",
    callMessage:
      "Your camera and audio will be turned off when you receive a call.",
    noStatus: "No status",
    offline: "Off-line",
    vacation: "On vacation",
    reasons: {
      reason: "Reason",
      eating: "Eating",
      resting: "Resting",
      focused: "Focused",
      call: "In a Call",
      vacation: "On Vacation",
      anotherReason: "Another Reason",
    },
  },
  actions: {
    avatar: "Avatar",
    pet: "Pet",
    chat: "nubi chat",
    exit: "Exit",
    logout: "Log Out",
    workInOffice: "I am in the office",
    manageSpaces: "Manage space",
    manageCampus: "Manage campus",
    profile: "My profile",
    sendConsoleMessage: "Send general announcement",
    videoCallSettings: "Video Call Settings",
    support: "Help/Support",
    multiplayerToolKit: "Power-ups",
    config: "Configuration",
    sendConsoleMessageMultiespacio:
      "If you have more than one space on this campus, send it to ALL",
    utilities: "Utilities",
  },
  auth: {
    welcome: "Welcome",
    forgot: "Forgot your password?",
    backToLogin: "Back to Login",
    forgotTitle: "Request password change",
    resetTitle: "Enter your new password",
    pinlink: "Access with a PIN that we send to your emaill",
    pinTitle: "Request access PIN.",
    pinLoginTitle: "Access with PIN.",
    pintDescription: "Enter your email associated with the nubi account.",
    welcomeGicar: "Access with corporate credentials (Gicar)",
  },
  manageSpaces: {
    sidebar: {
      users: "Users",
      manageUsers: "Manage space users",
      inviteUsers: "Add users",
      pendingUsers: "Pending users",
      space: "Space",
      customizeSpace: "Customize",
      customizeRooms: "Manage rooms",
      wonderPoints: "WonderPoints",
      campusSpaces: "Campus spaces",
      spaceSettings: "Configuration",
      multiSpace: "Campus",
      customizeMultiSpace: "Customize",
      settingsMultiSpace: "Configuration",
      manageUsersSuperSpace: "Manage campus users",
      goToCampus: "Go to campus",
      announcements: "Announcements",
      announcementsCampus: "Campus announcements",
      announcementsSpace: "Space announcements",
      posters: "Manage posters",
    },
    customizeSuperSpace: {
      logoImage: "Campus logo",
      uploadLogoImage:
        "This image corresponds to the logo that users will see in the city",
      changeWebinarType:
        "Are you sure to change the webinar type of the space, this could affect the webinar in progress",
    },
    customizeSpace: {
      warningOpenUrl: "Warning, not all urls can be opened within nubi",
      openUrlExternally: "Automatically open in a new tab.",
      selectScene: "Select space",
      logoImage: "Space logo",
      uploadLogoImage:
        "This image corresponds to the logo that users will see in the menu.",
      uploadBackgroundImage:
        "This image will be used in the landing page that will be generated (in the future) when creating a space",
      boardImage: "Entrance sign",
      uploadBoardImage:
        "This image is the one shown on the sign that is on the main door of the space",
      uploadCommonImage:
        "In case there are undefined room screens, this image will be used to show it by default",
      roomImage: "Room screens",
      uploadRoomImage:
        "This image will be used by default on all the screens in each room of the space.",
      uploadOneRoomImage:
        "Add an image here. It will be used for every screen in this room.",
      selectRoom: "Select the room",
      editRoom: "Edit the room values",
      selectPoster: "Select the poster",
      editPoster: "Edit the poster values",
      posterImage: "Poster image",
      uploadPosterImage: "This image is to be used on the poster.",
      urlPoster: "Pinned link to poster",
      noPosters: "There are no posters in this space",
    },
    inviteUsers: {
      title: "Hello! What kind of user do you want to add?",
      userDescription:
        "Has email and password.Registration required.Permanent user in the space",
      guestDescription: "Has no email or password.Just visiting.Temporary user",
      orShareLink: "Or share this link",
      addGuidedVisit: "Add guided visit",
      sendInvitations: "Send invitation",
      newInvitation: "New invitation",
      withOnboarding: "Onboarding will be shown when entering the space",
      alwaysGoToRoom: "Always automatically go to the room.",
      generateNewUrl: "Generate new link",
      confirmGenerate:
        "Are you sure to re-generate this url? Users will not be able to access using the previous url.",
      pendingInvitations: "Pending invitations",
      grazingDescription:
        "choose which room you want the user to go to automatically (the first time they login)",
      noGrazing: "Non-guided visit",
      guestInvitation: "Only a guest",
      userInvitation: "nubi user",
      selectLanguage: "Select the language in which the invitation is sent",
      dateExpiration: "The invitation expires on",
    },
  },
  manageUsers: {
    group: {
      groups: "Groups",
      createGroup: "Create group",
      editGroup: "Edit group",
      editUsers: "Edit users"
    },
    table: {
      user: "User",
      email: "Email",
      enabled: "Enabled",
      disabled: "Disabled",
      lastConnection: "Last Connection",
      noLastConnection: "User never connected",
      name: "Name",
      space: "Space",
      spaceType: "Space type",
    },
    permissions: {
      title: "Permissions",
      canInvite: "Can invite more users",
      isAdmin: "Can manage the space",
      isCampusAdmin: "Can manage the campus",
      isWebinarHost: "Is a webinar speaker",
      isMultiWebinarHost: "Is a webinar speaker on campus",
      onlyInMultiWebinar: "Only when the multi webinar is active",
      globalMessage: "Can send announcements",
      isTrial: "Intern",
      isEmployed: "User",
      canPinChatMessage: "Can pin messages",
      canBan: "Can ban other users",
      canChangeRoomPin: "Can change room security CODE",
      disableIsAdmin: "Campus or space admins cannot be disabled.",
      disableIsCampusAdmin: "Campus admins cannot be disabled.",
      canUploadPhoto: "Can upload photos in PowerUps",
      canMuteAndCamera: "You can mute and turn off cameras in meeting rooms",
      canMuteAndCameraInstructions: "For this permission to take effect, the user must leave and enter the room",
      gobalPermission: "Global campus permissions",
      spacePermission: "Specific space permissions",
      noGlobalPermission: "There are no global permissions",
      canManageMeetingControl: "You can mute the microphone and turn off cameras during calls",
      canManageWebinar: "You can enable speakers in the webinar",
      rol: "User role",
      showSpotify: "Enable Spotify",
    },
    tooltip: {
      webinar: "Has webinar permissions",
      admin: "is administrator",
      canInvite: "Can invite users",
      globalMessage: "You can send announcements",
      canPinChatMessage: "Can pin messages",
      canBan: "Can ban other users",
      canChangeRoomPin: "Can change rooms access code",
      canUploadPhoto: "Can upload photos in PowerUps",
    },
    filter: {
      none: "Has no special role",
      all: "All users",
      webinar: "Is a webinar speaker",
      admin: "Can admin the space",
      canInvite: "Can invite users",
      globalMessage: "You can send announcements",
      isTrial: "Is an intern",
      disabled: "Disabled users",
      userOnline: "Online users",
      canPinChatMessage: "Can pin messages",
      canBan: "Can ban other users",
      canChangeRoomPin: "Can change rooms access code",
    },
    confirmDelete: {
      title: "Delete user from space",
      description:
        "Are you sure to delete this user, he/she will not be able to enter this space again?",
    },
  },
  announcements: {
    addNew: "Create new announcement",
    title: "Announcement title",
    frequency: "Repeat",
    justOne: "Just once",
    everyHalfHour: "Every half hour",
    everyHour: "Every hour",
    time: "Send at",
    text: "Announcement text",
    timeToSend: "Shipping date",
    confirmDelete: {
      title: "Delete announcement",
      description: "Are you sure you want to remove this announcement?",
    },
    successDelete: "Announcement removed successfully",
    successCreate: "Announcement create successfully",
    chexboxText: "Repeat this announcement every {day}",
    text1: "From campus",
    text2: "From space",
    repeat: "Is repeated",
    every: "Every {day}",
    no: "Not",
  },
  profile: {
    sidebar: {
      general: "General",
      security: "Security",
      social: "Social",
      logs: "Events log",
      videoAudio: "Configure devices",
      knowledge: "Skill",
      curriculum: "Curriculum",
    },
    security: {
      veryWeakPassword: "Very Weak password",
      weakPassword: "Weak password",
      securePassword: "Secure password",
      strongPassword: "Highly secure password",
      differentPassword: "Password does not match",
    },
    confirmUnsubscribe: {
      title: "Delete my nubi account",
      checkBoxText: "Delete account",
      description:
        "Do you really want to delete your nubi account? You will not be able to access with this user.",
    },
  },
  consoleMessage: {
    title: "New announcement",
    all: "All",
    noSound: "No sound",
    dingDong: "Ding Dong Ding",
  },
  newMessage: {
    title: "New direct message",
  },
  paperPlane: {
    title: "New paper airplane",
  },
  configDevices: {
    videoConference: "nubi has videoconferencing functions...",
    chooseDevices: "Can you see yourself?",
    noPermissions: "No access to microphone and camera",
    popupPermissions:
      "You must give us permission to use your camera and microphone.",
    allowPermissionsText:
      "Allowing Google Chrome to access my camera and microphone",
    allowPermissions: "Allow access",
    skip: "Skip this part",
    skipModal: "Are you sure? The camera and microphone will not work in nubi.",
    clickAllow: 'Click on "Allow" in the browser pop-up window.',
    havingIssues: "Having problems?",
    browsersStuck: "Browsers sometimes fail to capture the camera. To fix this",
    refreshPage:
      "Try refreshing the page. We have modified the camera settings to make it more likely to work.",
    checkPermissions: "Check your browser's camera and microphone permissions",
    help: "If that doesn't work",
    contactUs: "Contact us",
  },
  webinarUrlModal: {
    title: "Share video in the webinar",
    activeWebinar: "Start Webinar",
    description:
      "When you press START you will activate the webinar mode of this area in nubi. Once started, only those that are granted webinar permissions will have their camera and mic on, the rest of the users will ONLY be able to watch, listen, and text chat. You can add a Youtube URL if you wish for anyone in the webinar area to see. It’s OPTIONAL.",
    cancelWebinar:
      "Are you really sure to close the webinar? everyone inside will be disconnected immediately",
  },
  meetingUrlModal: {
    title: "Share video",
    description: "You can include a youtube link for it to play",
    autoplay: "Autoplay",
  },
  otherReasonModal: {
    title: "Indicate another reason why you are busy",
  },
  changeSpaceModal: {
    description:
      "These are the spaces that you have available and that you can visit. To go to another space, click on the one you want in the list and you will be automatically redirected. ",
    active: "You are here",
  },
  confirmBanModal: {
    text: "When it is expelled, the user will also be disabled until you change it in the users menu.",
    buttonConfirm: "Confirm",
    buttonCancel: "Cancel",
  },
  vacationModal: {
    title: "When are you coming back from vacation?",
    label: "Let your colleagues know when you will return to nubi.",
    error: "Select the date of your return from vacation",
  },
  callErrorModal: {
    title: "Information",
    text: "You've been alone with your cam on for a while. We've close your call for privacy just in case",
    callReset: "Reconnect to call",
  },
  check: {
    checkEmail: "The e-mail address is invalid",
  },
  changeAvatar: {
    title: "Select your avatar",
  },
  changePet: {
    title: "Select your pet",
  },
  onBoarding: {
    welcome: {
      welcome: "Welcome to",
      welcomeDescription:
        "This is your space up in the nubi! Connect with your peers and feel like you are together, no matter where they are. Are you ready?",
      welcomeDescriptionLine2: "Are you ready? We hope you enjoy the ride!",
    },
    suggestions: {
      noShow: "Do not show again",
      one: "To scroll through nubi, double click on the place you want to go.",
      two: "You can zoom in or out on the screen to see the entire nubi space without moving your avatar from its site.",
      three:
        "There are certain meeting rooms in nubi where upon entering, your camera and microphone will automatically activate.",
      four: "Chat with other avatars through direct messages, private 1: 1 calls or in the room chat.",
      five: "If you are invited to two or more nubi spaces, here you can choose which space you want to visit and travel from one to the other easily.",
      six: "If you click on a user you can interact with him and send him paper planes with messages to get his attention.",
    },
  },
  confirmInvite: {
    inviteUser:
      "You must enter your email, you will receive a confirmation email to validate your account and be able to enter the space.",
    inviteGuest: "You need to add your name before you can join the space",
    expireOn: " Expires on ",
  },
  gdpr: "Following the recommendations of",
  gdpr2:
    "we inform you that the personal information you fill in will be shared with all users of the space. Do not fill in what you do not want to share or write to us at ",
  gdpr3: "to completely delete your account.",
  loader: {
    loadingData: "Hello!",
    loadingSpaces: "Where are my keys?",
    loadingUser: "I found them!",
    connectingServices: "Just checking everything is ok",
    loadingUsers: "Will everyone come?",
    preparingSpace: "Turning on the lights",
    creatingSspace: "Preparing some coffee",
    checkingSpace: "Today is gonna be a great day",
    connectingRoom: "Joining the room",
  },
  maintenance: {
    maintenance: "MAINTENANCE",
    maintenanceMessage:
      "We are performing maintenance work to upgrade our system. The maintenance is scheduled from {start} to {finish}.",
    maintenanceMessageError:
      "We are performing maintenance work to upgrade our system.",
  },
  webGLContextLost: {
    title: "Something went wrong...",
    content: "Click on the button below to reload nubi.",
  },
  photonError: {
    title:
      "We're unable to connect with nubi services. Please, check your network's stability. If you’re using a corporate network, this issue is probably a result of a firewall. If this is the case, please contact your organization’s network administrator. ",
    buttonTitleBegin: "CLICK THE FOLLOWING BUTTON",
    buttonTitleEnd: "to understand nubi’s network connection.",
    button: "Network requirements",
  },
  networkRequirementsTitle: "Here's a list of the ports nubi may use:",

  googBye: "You leaving?",
  goodbyeText:
    "If you have not decided to leave, it may be that we have detected that you may perhaps have forgotten about nubi and we are disconnecting you so that other avatars do not bother you. If you rather not exit, click on the button to return.",
  placeholder: {
    email: "example@email.com",
    selectTypeSpace: "Select the type of space",
    selectSpace: "Select the space",
    dniOrNie: "DNI o NIE",
  },
  tutorial: {
    step1:
      "Before even starting with nubi, let's show you in three simple steps how to use it.",
    step2:
      "1- It's time to move!. Use your MOUSE POINTER to DOUBLE CLICK anywhere on the ground (grey rug) and and your avatar will get going!",
    step3:
      "2- Congrats! Let's join a call. To activate your CAMERA and MIC, simply click inside a MEETING ROOM and it will automatically set up your camera and mic to start a video call with the people in the room!",
    step4:
      "3- Excellent! Last step: how to interact with other avatars/users. CLICK on ALEX and you will see the list of possible actions, such as chat, call, send a paper airplane, or see other users info, CLICK ON ANY OF THEM to finish the tutorial!",
    stepComplete: "Congratulations!",
    tutorialComplete:
      "FANTASTIC!!!, you have completed the tutorial, let’s head over to nubi.... Enjoy the experience.",
  },
  goodMorning: {
    one: "Hard work, a positive mind and getting up early are the keys to having a great day.",
  },
  invitationsActions: {
    deleteInvitation: "Delete invitation",
    increaseInvitation: "Increase expiration time",
    descriptionDelete: "Do you really want to delete this invitation?",
    descriptionIncrease:
      "Do you really want to increase the expiration time of this invitation?",
  },
  toolkit: {
    NUBII_TOOLS_MESSAGE_IMAGE_UPLOADED:
      "{name} has uploaded a new photography.",
    NUBII_TOOLS_MESSAGE_NEW_POLL: "{name} has created a new poll.",
    NUBII_TOOLS_MESSAGE_PPPS_REMINDER:
      "Remember that PPPS form is available today.",
  },
  callMenu: {
    background: "Select background",
    record: "Record call",
    blur: "Background blur",
    walkie: "Push to talk (Key N)",
    noise: "Enable noise cancellation",
    config: "Config devices",
    muteAll: "Mute everyone",
    videoOffAll: "Turn off everyone's video",
    video: "Video",
    mic: "Microphone",
    otherOptions: "Other options",
    resetCall: "Restart the call",
  },
  recordGuide: {
    title: "nubi recording tool.",
    step1: "Click on the red button to start recording.",
    step2:
      "A view will appear with the screen, window or tab you want to record, select the one you want (preferably the nubi tab).",
    step3: "You can pause and resume the recording whenever you want.",
    step4:
      "Click stop to end the recording and it will be automatically downloaded to your browser.",
    step5: "We recommend you download",
    step5_2: "to see the nubi videos",
  },
  callIsRecord: "The call is being recorded",
  recordCall: "Record call",
  knowledgeRecord: "Record knowledge",
  knowledgeRecording: "Recording knowledge",
  knowledgeRecordTitle: "Record your knowledge",
  autoVideo: {
    title: "Finally, add a title, a description and save, or reject if you are not happy with the result and do not want to save it.",
    notSaved: "If you reject the video will not be saved",
    decline: "Decline",
  },
  recordingCall: "{name} is recording the call",
  confignubii: {
    call: "Call",
    notification: "Notifications",
    sound: "Sound",
    disableMic: "Always start with microphone off",
    disableCam: "Always start with camera off",
    volume: "Call volume",
    silenceNotifications: "Mute notifications",
    silenceReactions: "Mute reactions",
    scene: "Scene",
    chat: "Chat",
    defaultChatOpen: "Always show the open chat when entering a call",
    disableSoundNotification: "Unmute notification",
    activeSendMailChat: "Click to stop sending chat summary at the end of the session.",
    disableSendMailChat: "Click to send a chat summary at the end of the session.",
  },
  admin: {
    sidebar: {
      analytics: "Analytics",
      goBack: "Go back",
      dashboard: "Dashboard",
      spaces: "Spaces",
      multi_spaces: "Campus",
      users_list: "Users",
      spaces_requests: "Space requests",
      new_space: "Create new space",
    },
    actions: {
      enabled: "Enable space",
      disabled: "Disable space",
      delete: "Remove space",
    },
    confirmDeleteSpace: {
      title: "Remove space",
      description: "Are you sure to delete this space?",
    },
    confirmDisabledSpace: {
      title: "Disable space",
      description: "Are you sure to disable this space?",
    },
    request_space: {
      spaceName: "Name of the space",
      creatorEmail: "Creator's email",
      spaceType: "Type of space",
      activationUrl: "Activation link",
      creationDate: "Creation date",
    },
    dashboard: {
      welcome: "Bienvenido",
      welcomeDescription: "Aquí podras gestionar todo nubi",
      usersLogin: "Online users",
      dau: "Daily active users",
      wau: "Weekly Active Users",
      mau: "Monthly active users",
    },
  },
  webinarModal: {
    title: "Webinar",
    enterWebinarSpan: "ATTENTION: ",
    enterWebinar1: "Welcome to the WEBINAR room.",
    enterWebinar2:
      'This is a space for WEBINARS. Only users with "Speaker" permissions will be able to activate their camera and audio, which will be turned off by default. Within the room any "Speaker" will be able to invite other users to participate.',
    cancel: "Cancel and go away",
    accept: "Accept and go to the meeting",
  },
  autoVideoEnterModal: {
    title: "Auto Video",
    enterAutoVideoSpan: "ATTENTION: ",
    enterAutoVideo1: "Welcome to the Auto Video room.",
    enterAutoVideo2:
      "This is a space for Auto Video. Inside the room, you can record knowledge.",
    cancel: "Cancel",
    accept: "Accept",
  },
  speedNetworkingModal: {
    title: "Speed Networking",
    connectWith: "Connected with",
    nextConnection: "Next connection in",
    preparingConnection: "Prepare for your next meeting",
    preparingConnectionDescription:
      "Waiting for your partner to start the connection",
    waitingMoreUsers:
      "Give us few seconds to set up while the rest of the users join",
    breakTime: "Take a break while we prepare your next meeting\n",
    enterSpeedNetworking1: "Welcome to the NETWORKING room.",
    enterSpeedNetworking2:
      'If you press "Enter" below, you will have 1-1 calls with every user in the room. At the end of each call we will connect you with another user. When you want to stop, simply walk out of the room.',
    enterSpeedNetworkingSpan: "ATTENTION: ",
    enterSpeedNetworking3:
      'If you DON´T want to chat with other users right now, click "Cancel". Enjoy the networking room!',
  },
  chatMenu: {
    general: "General chat",
    pinnedMessages: "Pinned messages",
    openChats: "Open chats",
  },
  userOnlineActions: {
    showProfile: "Show profile",
    call: "Call",
    chat: "Chat",
    disable: "Disable",
    enable: "Enable",
    goToSpace: "Go to space",
  },
  messageActions: {
    pinMessage: "Pin message",
  },
  roomPin: {
    changePin: "You can assign an ACCESS code to the room to make it private",
    enterPin: "You must enter an ACCESS code to enter the room",
    pinNull: "if you leave the ACCESS code blank, the room will be open",
    addPin: "Apply security ACCESS code",
    removePin: "Release room",
    errorPin: "The ACCESS code is wrong",
    doneChangePin: "ACCESS code successfully assigned",
    doneReleaseRoom: "Room released successfully",
    doneReleasePin: "Successfully released rooms",
    releasePins: "Release all rooms that have an ACCESS code",
    textfootchangePin: "This room is permanently locked",
    enterPinNotepad: "You must enter the PIN of the room",
  },
  spaceType: {
    OFFICE_TYPE: "Office",
    EVENT_TYPE: "Event",
    EKAM_TYPE: "Meditation space",
    LEARNING_TYPE: "Learning",
    MINISO_TYPE: "Ecommerce space",
  },
  sceneType: {
    SMALL: "Small",
    MEDIUM: "Medium",
    LARGE: "Large",
    AUTOMOTIVE: "Automotive",
    CONFERENCE_CENTER: "Small conference",
    CONFERENCE_CENTER_LARGE: "Large conference",
    CONFERENCE_COFFEE: "Coffee shop",
    CONFERENCE_WEBINAR: "Conference with webinar",
    CONFERENCE_WEBINAR_SPEED_NETWORKING:
      "Conference with webinar and Speed Networking",
    FESTIVAL: "Concert",
    LAKE_SINGLE_WEBINAR: "Lake with webinar",
    TEMPLE: "Temple",
    MINISO: "Online store",
    LEARNING: "Learning",
    RECREATIVE: "Recreative",
    AUDITORIUM: "Auditorium",
    LAKE_SINGLE_WEBINAR_LARGE_WITH_BOOTHS: "Great lake with webinar",
    WEBINAR_SPEED_NETWORKING_PLATFORM:
      "Platform with webinar and Speed Networking",
    OFFICE_PLATFORM_NORMAL: "Office platform",
    AUDITORIUM_MINI: "Mini Auditorium",
    LEARNING_PLATFORM: "Learning Platform",
    GAMING_PLATFORM: "Gaming Platform",
    OFFICE_PLATFORM_NORMAL_TWO: "CTTI",
    AUDITORIUM_PLATFORM: "Auditorium platform",
    HAWKINGS_LARGE: "Large Hawkings",
    SHOWROOM_SMALL: "Showroom small",
    SHOWROOM_VERY_SMALL: "Showroom very small",
    SHOWROOM_NORMAL: "Showroom normal",
    SHOWROOM_LARGE: "Showroom large",
    SHOWROOM_BIG: "Showroom big",
    SHOWROOM_SUPER_BIG: "Showroom super big",
    SHOWROOM_NETWORKING: "Showroom networkings",
    SHOWROOM_SUPER_OFFICE: "Showroom super office",
    SHOWROOM_INVESTIGATION: "Showroom investigation",
    SHOWROOM_SUPER_BIG_WITH_NETWORKING_NO_WALL: "Showroom super big no wall",
    SHOWROOM_FOREST: "Showroom forest",
    SHOWROOM_OASIS: "Showroom oasis",
    SHOWROOM_TROPICAL: "Showroom tropical",
    SPACE_ISLANDS: "Space islands",
    SPACE_ISLANDS_XRF: "Space islands xrf",
    SPACE_ENEB : "Space eneb",
    CTTI_BURRA_CLUB: "La burra club",
    ENEB_SPACE_ISLANDS_BLUE : "Space eneb islands",
    HESPERIDES_ISLANDS: "Hesperides Islands",
  },
  languages: {
    en: "English",
    ca: "Catalan",
    zk: "Mandarin Chinese",
    hi: "Hindi",
    es: "Spanish",
    fr: "French",
    ar: "Arab",
    ru: "Russian",
    pt: "Portuguese",
    id: "Indonesian",
    de: "German",
    ja: "Japanese",
    tr: "Turkish",
    ko: "Korean",
    it: "Italian",
  },
  goodbyeUnsubscribe: "We will miss you, thank you for being part of nubi.",
  goToNubiWeb: "Go to the nubi website for more",
  openLink: "Open link",
  posterRedirect:
    "This poster contains a website of interest. If you accept, you will be redirected to an external nubi page.",
  chat: {
    confirmDelete: {
      title: "Clean chat",
      description:
        "Are you sure you want to delete the messages from the general chat? You will not be able to see the messages prior to this action.",
    },
    userDelete: "User deleted"
  },
  layoutTypes: {
    COLUMN: "Single column",
    GRID: "Grid",
    COLUMN_LEFT: "Column to the left",
    // COLUMN_RIGHT = "COLUMN_RIGHT",
    COLUMN_TRANSPARENT_LEFT: "Column on the left",
    TOP_ROW: "Top row",
    TOP_SHARE: "Share big",
  },
  callModal: {
    title: "is calling you",
    restart: "Are you sure you want to restart the call?",
  },
  chatContent: {
    today: "Today",
    yesterday: "Yesterday",
  },
  configurationSuperSpace: {
    titleButton: "Add IP to automatically check if users are at office or home",
    from: "From",
    to: "To",
    range: "Range",
    no: "No",
    yes: "Yes",
    textCheckBoxFalse: "Mark to add IP by range",
    textCheckBoxTrue: "Uncheck to add IP",
    ipNoValid: "Invalid IP",
    alreadyExists: "IP already exists",
    rangeAlreadyExusts: "IPS range already exists",
    rangoMax: "The final IP cannot be less than the initial one",
    confirmDelete: {
      title: "Delete IP",
      description: "Are you sure to remove this IP?",
    }
  },
  birthdayModal: {
    title: "Today is {name}'s birthday!",
    congratulateBirthday: "Happy Birthday!",
    birthdayMessage1: "Happy birthday, enjoy your day!",
    birthdayMessage2: "Congratulations, enjoy, you deserve it!",
    birthdayMessage3: "May you have many more!",
    birthdayMessage4: "Congratulations, one year younger!",
    birthdayMessage5: "Have a wonderful birthday!",
  },
  favouriteSpace: {
    campus: "Campus",
    favouriteSpace: "Favorite spaces",
    modalFavouriteSelector: {
      title: "Favorite spaces",
      noFavourite: "You don't have favorite spaces",
    }
  },
  callContentComponent: {
    waiting: "Connected. Waiting for the presenters...",
  },
  eventCalendarComponent: {
    empty: "There are no events scheduled",
  },
  codeErrorApi: {
    ERROR_ROOM_INVALID_PIN: "Invalid PIN",
  },
  loginMicrosoft: {
    loading: "Identifying..."
  },
  floatingMenu: {
    poll: "Poll",
    notepad: "Notepad"
  },
  poll: {
    vote: "Vote",
    endPoll: "Delete poll",
    pollEnded: "Poll Ended",
    currentPoll: "Current Poll",
    createNewPoll: "Create a new poll",
    question: "Question",
    responses: "Responses (Minimum 2)",
    duration: "Duration",
    pollSuccessNotifications: "Poll created successfully",
    confirmCancelPoll: "Are you sure to delete the poll?",
  },
  robot: {
    helpYou: "Hello, I'm {name}. How can I help you?",
    questionHere: "Write your question here",
    sendQuestion: "Send question",
    waitingResponse: "Waiting for response",
    aiNotAvailable: "At this moment, artificial intelligence is not available",
  },
  register: {
    activeUser: "Welcome to Hawkings, check your mail.",
    registeredUserError: "The user is already registered",
    activationAlreadyDone: "Activation has already been done",
    country: "Country",
    registerHere: "Don't have an account? Register here",
    register: "Sign Up",
    termsAndConditions1: "By proceeding, you acknowledge and accept our",
    termsAndConditions2: "Terms and Conditions",
    termsAndConditions3: "and",
    termsAndConditions4: "Privacy Policy",
    back: "Go back to the start",
    name: "Name",
    yourName: "Your name",
    lastName: "Last name",
    yourLastName: "Your last name",
    emailAddress: "Email address",
    emailAddressExample: "your@mail.com",
    select: "Select",
    password: "Password",
    yourPassword: "Your password",
    confirmYourPassword: "Confirm your password",
    passwordConfirmation: "Password confirmation",
  },
  education: {
    selectRole: "Select the role",
    teacher: "Teacher",
    student: "Student",
    staff: 'Staff',
    teacherTooltip: 'Restricted access to specific spaces and rooms. Cannot moderate or access teacher tools.',
    studentTooltip: 'Access to educational tools, can moderate rooms, and has the ability to add educational content.',
    staffTooltip: 'Limited access to administrative tools, can moderate, and has permissions to add or remove users in a specific space.',
    superAdminTooltip: 'Full control over all aspects of the campus, including role and permission administration.',
  },
  hawkings: {
    questionHere: "Your message",
    sendQuestion: "Send message",
    newConversation: "+ New conversation",
    examGenerator: "Exam Generator",
    examGeneratorDescription: "This tool assists you in the creation of exams, tailoring them to the level and needs of each group of students. For instance, how would you create an exam to assess basic math knowledge in elementary school children? And how would you design a test for an advanced physics course? The app streamlines this process, ensuring fair and balanced assessments.",
    educationLaw: "Education Law",
    selectEducationalLaw: "Select an education law",
    subjects: "Subjects",
    selectSubject: "Select a subject",
    educationalProgram: "Educational program",
    questions: "Questions",
    numberQuestions: "Number of questions",
    additionalComments: "Additional comments",
    anyAdditionalInstructions: "Any additional instructions for generating the exam",
    language: "Language",
    selectLanguage: "Select a language",
    generateButton: "Generate",
    untitledDocument: "Untitled document...",
    deleteButton: "Remove",
    download: "Download",
    copyToClipboard: "Copy to clipboard",
    examCopiedClipboard: "Exam copied to the clipboard",
    course: "Course",
    selectCourse: 'Select a course',
    tools: "Tools",
    chatBot: "Chatbot",
    clearInputs: "Clear Inputs",
    example: "Example",
    messageCopiedClipboard: "Copiat al porta-retalls",
    clickSelectAssistant: "Click to select the assistant",
  },
  CTTI: {
    questionGameModalText: "Do you want to play?",
    spotyfyModal: {
      title: "Do you want to listen to this week's selected playlist?",
      openWeb: "To open from the web",
      openApp: "To open from the application",
      addList: "Add your playlist",
      addTitle: "How to copy the URL of the playlist you want to share from Spotify, from the web",
      addTitle1: "here",
      addTitle2: "and from the application",
      tutorial: "Click on the three dots - Share - Copy playlist link, then paste it into the container and add",
      add: "Add",
      sidebarListToMusic: "To listen to music",
      listOf: "The selected list is from",
      close: "Close",
    },
    calendar: {
      calendarTitle: "Calendar",
    },
    reservationRoom: {
      reserveVirtualRooms: "Reserve virtual room",
      toReserve: "To reserve",
      created: "Created by",
      room: "Room",
      of: "From",
      to: "To",
      roomNoName: "Unnamed Room",
      title: "Title",
      shortDescription: "Short description",
      selectTheRoom: "Select the room",
      selectTheReservationTime: "Select the reservation time",
      invalidRange: "Invalid range",
      reservedHours: "Reserved hours",
      selectTheUsersYouWantToInvite: "Select the users you want to invite",
      selectedUsersToInvite: "Selected users to invite",
      inviteExternalUsersWithYourEmail: "Invite external users with their email",
      editReservation: "Edit reservation",
      accessPin: "Access PIN",
      reserveVirtualRoom: "Virtual room",
      reservePhysicalRoom: "Physical room",
      description: "Description",
      googleMeet : "Google Meet",
      signOut: "Sign out",
      signInGoogle: "Sign in with Google",
      signInHotmail: "Sign in with Hotmail",
    },
    reservationsPhysicalRoom: {
      reserveVirtualRooms: "Reserve physical room",
      selectPlant: "Select the floor",
      selectRoom: "Select the room",
    },
  },
  gameKiller: {
    answers1: "In a dramatic turn of events, players have located and challenged the zombie {data}, securing safety for everyone. Congratulations on a game well played!",
    answers2: "Silence falls over the scene... The zombie {data} has triumphed in the shadows, claiming victory over all. Better luck next time.",
    answers3: "After intense debate, the decision is unanimous: no one will be expelled this round. Tension rises as the game continues.",
    answers4: "{data} was expelled after the vote, sealing their fate amid laments. The truth reveals itself bitter; they were innocent, and their departure only leaves more unanswered questions.",
    report: "Report",
    title: "Zombie Game",
    eliminated: "Infected",
    minimize: "Minimize",
    information: "Information",
    vote: "Vote",
    titleReport: "Select a user and write a brief text on why you think that player should be eliminated",
    selectUser: "Select User",
    textRepor: "Brief text explaining why they must be eliminated",
    sendReport: "Send Report",
    titleVote: "Vote to eliminate {data1}, reported by {data2} with the following message: {data3}",
    yes: "Yes",
    no: "No",
    resultWaiting: "Waiting for result",
    sendVote: "Send Vote",
    titleActive: "The Zombie Game is active",
    tutorial1Title: "General Description",
    tutorial1: "This is a game where participants find themselves in a mysterious scenario in which one of them is designated as a zombie. The game's goal is to discover the identity of the zombie before it manages to infect all other participants. Throughout the game, players will need to use their wits and intuition to survive and solve the mystery.",
    tutorial2Title: "How to play as the zombie",
    tutorial2: "If you turn out to be the zombie, you will have the ability to infect your companions. This is achieved by clicking on a specific user. If clicking shows a syringe icon, it means you have the possibility to infect that player. You must proceed with caution: clicking on the syringe icon, you will stealthily approach your target, and once you're close enough, you will infect them. Infected players will be identifiable by a distinct icon above their head. It's important to remember that if you've been infected, you are out of the game, unable to report or communicate to the other players who infected you.",
    tutorial3Title: "How to report the zombie",
    tutorial3: "If you suspect who might be the zombie, or if you are convinced of their identity, you have the option of signaling them through a specific button to make reports. After using this button, a cooldown period will be activated that will prevent you from making another report immediately. You must choose the player you believe is the zombie and provide a concise explanation of your suspicions. This will initiate a vote with a predetermined duration, allowing other players to vote for or against the accusation. If the vote concludes affirmatively and the accused turns out to be the zombie, all players win. However, if the vote ends with the elimination of an innocent, and you were the one who made the report, you won't be able to report another player for the next 48 hours, and the game will proceed without the eliminated player. If the vote is negative, the game continues normally without affecting the accused. The zombie is declared the winner if it manages to infect the rest of the players without being discovered.",
    tutorial4Title: "How to play if you are not the zombie",
    tutorial4: "If you are not the zombie, your goal will be to survive and collaborate with other players to identify the culprit. Stay alert to suspicious behavior, use the report button wisely, and actively participate in discussions and voting. Remember, your instinct and ability to deduce will be key to unmasking the zombie before it's too late.",
    zombie: "Zombie",
    Innocent: "Innocent",
    blockDelete: "You cannot infect while voting is active",
    blockKillerDelete: "You must wait {data} before you can proceed with elimination",
    howToPlay: "How to Play",
    infected: "Infected",
    lastDead: "Last infected {data}",
    gameDiary: "Game diary",
  },
  usersGround: {
    groups: "Groups",
    createGroups: "Create group",
    editGroup: "Edit group",
    editUsers: "Edit users"
  },
  level: {
    NATIVE: "Native",
    LOW: "Low",
    MEDIUM: "Medium",
    HIGH: "High"
  },
  gender: {
    ML: "Male",
    FM: "Female",
    OTHER: "Other",
    NONE: "Leave Blank"
  },
  plans: {
    premium: "Premium",
    title: "Discover the Premium Plan: Take Your Experience to the Next Level!",
    description: "Are you ready to enjoy the best our website has to offer? With the Premium Plan, you'll unlock a range of exclusive benefits designed to provide you with more value, convenience, and advantages than ever before.",
    seeBenefits: "See Benefits",
    hirePlan: "Subscribe to Plan",
    maxSimultaneusConnections: "The maximum number of simultaneous connections has been reached. Please wait for an available spot.",
    "features": {
      "UserLink": "User Link",
      "UserLinkDescription": "Generate an invitation link for anyone you want to be a recurring user of your space.",
      "GuestLink": "Guest Link",
      "GuestLinkDescription": "Generate an invitation link for anyone you want to be a one-time guest user in your space.",
      "FavoriteSpace": "Favorite Space",
      "FavoriteSpaceDescription": "Mark your favorite spaces.",
      "SearchFilters": "Search Filters",
      "SearchFiltersDescription": "Filter by knowledge, subject matter experts, and projects within your user group.",
      "UserListRolls": "User List Roles",
      "UserListRollsDescription": "Display the job role of each user.",
      "UserProfile": "User Profile",
      "UserProfileDescription": "Full profile with all user information.",
      "GeneralChat": "General Chat",
      "GeneralChatDescription": "General chat for all users within the space.",
      "RoomsChat": "Room Chats",
      "RoomsChatDescription": "Exclusive chat for users within each room.",
      "PrivateChat": "Private Chat",
      "PrivateChatDescription": "Private chat with any user in the space.",
      "Powerups": "Powerups",
      "PowerupsDescription": "Selection of tools like task tracking, weekly reports, vacation forms, photo albums, etc.",
      "Reactions": "Reactions with and without Sound",
      "ReactionsDescription": "Reactions in chats, with or without sound (applause, drums, etc.).",
      "SpotifyList": "Spotify Playlists",
      "SpotifyListDescription": "Share Spotify playlists with your teammates.",
      "VirtualRoomBooking": "Virtual Room Booking",
      "VirtualRoomBookingDescription": "Reserve virtual rooms in Nubi.",
      "PhysicalRoomBooking": "Physical Room Booking",
      "PhysicalRoomBookingDescription": "Book your physical office rooms from Nubi.",
      "CampusSpaces": "Campus with Different Spaces",
      "CampusSpacesDescription": "Create a campus with multiple spaces within.",
      "Support": "Support",
      "SupportDescription": "Write directly to Nubi support for assistance.",
      "DefaultPlace": "Set Your Default Place",
      "DefaultPlaceDescription": "Set your default location to appear each time you log in.",
      "ChangeStatus": "Change Your Status",
      "ChangeStatusDescription": "Update your status for other users to see.",
      "WorkFromHome": "Indicate Work from Home or Office",
      "WorkFromHomeDescription": "Specify where you're working from: home or office.",
      "CreateResume": "Create Your Resume and Link Social Media",
      "CreateResumeDescription": "Build your resume on your profile and include your social media links.",
      "CustomAvatars": "Custom Avatars",
      "CustomAvatarsDescription": "Choose and change your avatar anytime.",
      "CustomSpaces": "Fully Customizable Spaces",
      "CustomSpacesDescription": "Design and customize spaces to suit your needs.",
      "ChoosePet": "Choose Your Pet",
      "ChoosePetDescription": "Select a pet to accompany your avatar.",
      "Notepad": "Notepad",
      "NotepadDescription": "Take notes within the rooms.",
      "WeblinkPanels": "Weblink Panels",
      "WeblinkPanelsDescription": "Include links to websites or videos on panels within spaces.",
      "Webinars": "Webinars",
      "WebinarsDescription": "Rooms where users participate as listeners, viewing and hearing only the presenter.",
      "MeetingRooms": "Meeting Rooms",
      "MeetingRoomsDescription": "Calls where users can enable their cameras and microphones.",
      "NetworkingRooms": "Networking Rooms",
      "NetworkingRoomsDescription": "Connect users randomly in calls of 2-3 minutes.",
      "ShareScreens": "Share Multiple Screens",
      "ShareScreensDescription": "Display more than one screen at a time.",
      "RaiseHand": "Raise Hand to Speak",
      "RaiseHandDescription": "Notify other users that you want to speak or ask a question.",
      "BlurBackground": "Blur Your Background",
      "BlurBackgroundDescription": "Apply a blur effect to your background during video calls.",
      "CustomBackgrounds": "Custom Backgrounds",
      "CustomBackgroundsDescription": "Set a custom background for your video calls.",
      "NoiseCancellation": "Noise Cancellation",
      "NoiseCancellationDescription": "Eliminate background noise in calls.",
      "TurnOffVideos": "Turn Off Everyone's Videos",
      "TurnOffVideosDescription": "Disable the video of all users in the call.",
      "MuteEveryone": "Mute Everyone",
      "MuteEveryoneDescription": "Mute the microphones of all users in the call.",
      "BlockPrivateRooms": "Private Room Lock",
      "BlockPrivateRoomsDescription": "Protect rooms with an access code.",
      "ShareVideo": "Share a Video",
      "ShareVideoDescription": "Play a video within a room.",
      "CastVote": "Create a Poll",
      "CastVoteDescription": "Create polls for connected users.",
      "EventsAgenda": "Event Agenda",
      "EventsAgendaDescription": "Organize the event's schedule with an agenda.",
      "MuteNotifications": "Mute Notifications",
      "MuteNotificationsDescription": "Disable incoming notifications.",
      "Recording": "Meeting Recording",
      "RecordingDescription": "Record calls and keep them.",
      "ConcentrationMode": "Focus Mode",
      "ConcentrationModeDescription": "Hide Nubi's background to focus on presentations or calls.",
      "ChangeCameras": "Change Camera Layout",
      "ChangeCamerasDescription": "Adjust the arrangement of cameras as you prefer.",
      "RobotsRooms": "Rooms with Robots and AI",
      "RobotsRoomsDescription": "Include moving AI robots and bots within the rooms.",
      "PinMessages": "Pin",
      "PinMessagesDescription": "Pin important messages or delete them.",
      "Games": "Games",
      "GamesDescription": "Integrated entertainment features.",
      "GoogleCalendarIntegration": "Google Calendar Integration",
      "GoogleCalendarIntegrationDescription": "Sync with your Google Calendar.",
      "OutlookIntegration": "Outlook Integration",
      "OutlookIntegrationDescription": "Sync with your Outlook.",
      "TeamsIntegration": "Microsoft Teams Integration",
      "TeamsIntegrationDescription": "Connect with Microsoft Teams.",
      "DomainName": "Custom Domain",
      "DomainNameDescription": "Use a personalized domain with your corporate name.",
      "BookMeetings": "Book Meetings",
      "BookMeetingsDescription": "Schedule meetings directly from the platform.",
      "MobileApp": "Mobile App",
      "MobileAppDescription": "Available for mobile devices.",
      "BrandWithLogos": "Branding with Logos",
      "BrandWithLogosDescription": "Customize your space with your company's logos.",
      "BrandWithNames": "Branding with Room Names",
      "BrandWithNamesDescription": "Assign personalized names to each room in the space.",
      "WalkToAvatar": "Walk to Another Avatar",
      "WalkToAvatarDescription": "Guide your avatar to another user in the space.",
      "SendPaperPlane": "Send a Paper Plane",
      "SendPaperPlaneDescription": "Get another user's attention by sending them a paper plane.",
      "KickBanUser": "Kick or Ban Users",
      "KickBanUserDescription": "Remove or restrict users from the space.",
      "SendAnnouncements": "General Announcements",
      "SendAnnouncementsDescription": "Send messages to all users with or without sound.",
      "Metrics": "Metrics",
      "MetricsDescription": "Access statistical information about the users in the space.",
      "Multiwebinar": "Multiwebinar",
      "MultiwebinarDescription": "Enable simultaneous webinars across multiple spaces.",
      "CreateUserGroups": "Create User Groups",
      "CreateUserGroupsDescription": "Organize users into groups.",
      "EventLogs": "Event Logs",
      "EventLogsDescription": "View connection and disconnection logs.",
      "ScheduledAnnouncements": "Scheduled Announcements",
      "ScheduledAnnouncementsDescription": "Leave scheduled messages or notices.",
      "BusinessCards": "Business Cards",
      "BusinessCardsDescription": "Generate downloadable cards with user profile information.",
      "SelfRecording": "Self-Recording Videos",
      "SelfRecordingDescription": "Create recorded videos for other users.",
      "SSO": "Single Sign-On (SSO)",
      "SSODescription": "Centralized authentication to access the space.",
      "Zumbar": "Zumbar",
      "ZumbarDescription": "Privately notify a user of a mistake without others noticing.",
      "MaximumConnections": "Maximum Connections",
      "MaximumConnectionsDescription": "Up to a maximum of 200 simultaneous connections.",
      "MaximumSpaces": "Maximum Spaces",
      "MaximumSpacesDescription": "Up to a maximum of 20 spaces."
    }
  },
  nationality: {
    "AF": "Afghan",
    "AX": "Åland Island",
    "AL": "Albanian",
    "DZ": "Algerian",
    "AS": "American Samoan",
    "AD": "Andorran",
    "AO": "Angolan",
    "AI": "Anguillan",
    "AQ": "Antarctic",
    "AG": "Antiguan and Barbudan",
    "AR": "Argentine",
    "AM": "Armenian",
    "AW": "Aruban",
    "AU": "Australian",
    "AT": "Austrian",
    "AZ": "Azerbaijani",
    "BS": "Bahamian",
    "BH": "Bahraini",
    "BD": "Bangladeshi",
    "BB": "Barbadian",
    "BY": "Belarusian",
    "BE": "Belgian",
    "BZ": "Belizean",
    "BJ": "Beninese",
    "BM": "Bermudian",
    "BT": "Bhutanese",
    "BO": "Bolivian",
    "BA": "Bosnian and Herzegovinian",
    "BW": "Botswanan",
    "BV": "Bouvet Island",
    "BR": "Brazilian",
    "IO": "British Indian Ocean Territory",
    "BN": "Bruneian",
    "BG": "Bulgarian",
    "BF": "Burkinabé",
    "BI": "Burundian",
    "KH": "Cambodian",
    "CM": "Cameroonian",
    "CA": "Canadian",
    "CV": "Cape Verdean",
    "KY": "Caymanian",
    "CF": "Central African Republic",
    "TD": "Chadian",
    "CL": "Chilean",
    "CN": "Chinese",
    "CX": "Christmas Island",
    "CC": "Cocos (Keeling) Islands",
    "CO": "Colombian",
    "KM": "Comorian",
    "CG": "Congolese",
    "CD": "Congo (DRC)",
    "CK": "Cook Islander",
    "CR": "Costa Rican",
    "CI": "Ivorian",
    "HR": "Croatian",
    "CU": "Cuban",
    "CY": "Cypriot",
    "CZ": "Czech",
    "DK": "Danish",
    "DJ": "Djiboutian",
    "DM": "Dominican",
    "DO": "Dominican Republic",
    "EC": "Ecuadorian",
    "EG": "Egyptian",
    "SV": "Salvadoran",
    "GQ": "Equatoguinean",
    "ER": "Eritrean",
    "EE": "Estonian",
    "ET": "Ethiopian",
    "FK": "Falkland Islander",
    "FO": "Faroese",
    "FJ": "Fijian",
    "FI": "Finnish",
    "FR": "French",
    "GF": "French Guianese",
    "PF": "French Polynesian",
    "TF": "French Southern Territories",
    "GA": "Gabonese",
    "GM": "Gambian",
    "GE": "Georgian",
    "DE": "German",
    "GH": "Ghanaian",
    "GI": "Gibraltar",
    "GR": "Greek",
    "GL": "Greenlandic",
    "GD": "Grenadian",
    "GP": "Guadeloupe",
    "GU": "Guamanian",
    "GT": "Guatemalan",
    "GG": "Guernsey",
    "GN": "Guinean",
    "GW": "Guinea-Bissau",
    "GY": "Guyanese",
    "HT": "Haitian",
    "HM": "Heard Island and McDonald Islands",
    "VA": "Vatican",
    "HN": "Honduran",
    "HK": "Hong Kong",
    "HU": "Hungarian",
    "IS": "Icelandic",
    "IN": "Indian",
    "ID": "Indonesian",
    "IR": "Iranian",
    "IQ": "Iraqi",
    "IE": "Irish",
    "IM": "Manx",
    "IL": "Israeli",
    "IT": "Italian",
    "JM": "Jamaican",
    "JP": "Japanese",
    "JE": "Jersey",
    "JO": "Jordanian",
    "KZ": "Kazakhstani",
    "KE": "Kenyan",
    "KI": "I-Kiribati",
    "KR": "Korean (South)",
    "KW": "Kuwaiti",
    "KG": "Kyrgyzstani",
    "LA": "Lao",
    "LV": "Latvian",
    "LB": "Lebanese",
    "LS": "Basotho",
    "LR": "Liberian",
    "LY": "Libyan",
    "LI": "Liechtenstein",
    "LT": "Lithuanian",
    "LU": "Luxembourgish",
    "MO": "Macanese",
    "MK": "Macedonian",
    "MG": "Malagasy",
    "MW": "Malawian",
    "MY": "Malaysian",
    "MV": "Maldivian",
    "ML": "Malian",
    "MT": "Maltese",
    "MH": "Marshallese",
    "MQ": "Martiniquais",
    "MR": "Mauritanian",
    "MU": "Mauritian",
    "YT": "Mahoran",
    "MX": "Mexican",
    "FM": "Micronesian",
    "MD": "Moldovan",
    "MC": "Monegasque",
    "MN": "Mongolian",
    "ME": "Montenegrin",
    "MS": "Montserratian",
    "MA": "Moroccan",
    "MZ": "Mozambican",
    "MM": "Myanmar (Burmese)",
    "NA": "Namibian",
    "NR": "Nauruan",
    "NP": "Nepalese",
    "NL": "Dutch",
    "AN": "Netherlands Antilles",
    "NC": "New Caledonian",
    "NZ": "New Zealander",
    "NI": "Nicaraguan",
    "NE": "Nigerien",
    "NG": "Nigerian",
    "NU": "Niuean",
    "NF": "Norfolk Islander",
    "MP": "Northern Mariana Islander",
    "NO": "Norwegian",
    "OM": "Omani",
    "PK": "Pakistani",
    "PW": "Palauan",
    "PS": "Palestinian",
    "PA": "Panamanian",
    "PG": "Papua New Guinean",
    "PY": "Paraguayan",
    "PE": "Peruvian",
    "PH": "Filipino",
    "PN": "Pitcairn Islander",
    "PL": "Polish",
    "PT": "Portuguese",
    "PR": "Puerto Rican",
    "QA": "Qatari",
    "RE": "Réunionese",
    "RO": "Romanian",
    "RU": "Russian",
    "RW": "Rwandan",
    "BL": "Saint Barthélemy",
    "SH": "Saint Helenian",
    "KN": "Kittitian and Nevisian",
    "LC": "Saint Lucian",
    "MF": "Saint Martin (French part)",
    "PM": "Saint Pierre and Miquelon",
    "VC": "Saint Vincentian and Grenadine",
    "WS": "Samoan",
    "SM": "Sammarinese",
    "ST": "São Toméan",
    "SA": "Saudi",
    "SN": "Senegalese",
    "RS": "Serbian",
    "SC": "Seychellois",
    "SL": "Sierra Leonean",
    "SG": "Singaporean",
    "SK": "Slovak",
    "SI": "Slovenian",
    "SB": "Solomon Islander",
    "SO": "Somali",
    "ZA": "South African",
    "GS": "South Georgia and the South Sandwich Islands",
    "ES": "Spanish",
    "LK": "Sri Lankan",
    "SD": "Sudanese",
    "SR": "Surinamese",
    "SJ": "Svalbard and Jan Mayen",
    "SZ": "Swazi",
    "SE": "Swedish",
    "CH": "Swiss",
    "SY": "Syrian",
    "TW": "Taiwanese",
    "TJ": "Tajikistani",
    "TZ": "Tanzanian",
    "TH": "Thai",
    "TL": "Timorese",
    "TG": "Togolese",
    "TK": "Tokelauan",
    "TO": "Tongan",
    "TT": "Trinidadian and Tobagonian",
    "TN": "Tunisian",
    "TR": "Turkish",
    "TM": "Turkmen",
    "TC": "Turks and Caicos Islander",
    "TV": "Tuvaluan",
    "UG": "Ugandan",
    "UA": "Ukrainian",
    "AE": "Emirati",
    "GB": "British",
    "US": "American",
    "UM": "United States Minor Outlying Islands",
    "UY": "Uruguayan",
    "UZ": "Uzbekistani",
    "VU": "Vanuatuan",
    "VE": "Venezuelan",
    "VN": "Vietnamese",
    "VG": "British Virgin Islander",
    "VI": "U.S. Virgin Islander",
    "WF": "Wallis and Futuna",
    "EH": "Sahrawi",
    "YE": "Yemeni",
    "ZM": "Zambian",
    "ZW": "Zimbabwean"
  }
};
export default en;
